import { postFile, postWithToken, getRequestFile, post } from "@/api/http";
import store from "@/store";

export const checkFile = (formData: FormData) =>
  postFile("/filemanage/filecode/CheckFile", formData, true);

export const checkWebContract = (fileIds: number[]) =>
  postWithToken("/signtrustv3/contracts/WebContractsCheck", {
    fileId: fileIds,
    usrId: store.getters.userId,
    usrPhone: store.getters.getUserPhone,
  });

export const getImgSourceByFileId = (fileId: number) =>
  postFile("/filemanage/filecode/GetImg", { imgId: fileId });

export const getImgSourceListByFileId = (fileIds: number[]) =>
  postFile("/filemanage/filecode/GetImgs", { imgIds: fileIds });

export const uploadImage = (file: File) => {
  const formData = new FormData();
  formData.append("ManUsrId", store.getters.userId);
  formData.append("file", file);
  formData.append("CoId", store.state.coId);
  formData.append("SofId", String(store.state.sofId));
  return postFile("/filemanage/filecode/ImgUpload", formData, true);
};

export const uploadFile = (file: File) => {
  const formData = new FormData();
  formData.append("ManUsrId", store.getters.userId);
  formData.append("file", file);
  formData.append("CoId", store.state.coId);
  formData.append("SofId", String(store.state.sofId));
  return postFile("/filemanage/filecode/FileUpload", formData, true);
};

export const addFileToMyDocuments = (fileId: number, fileName: string) =>
  postWithToken("/signtrustv3/usr/AddMyfiles", {
    coId: store.getters.coId,
    fileId,
    fileName,
    manusrId: store.getters.userId,
    sofId: store.state.sofId,
    usrId: store.getters.userId,
    usrPhone: store.getters.getUserPhone,
  });

export const delFileFromMyDocuments = (fileId) =>
  postWithToken("/signtrustv3/usr/DelMyfiles", {
    appendFileId: fileId,
    operateUsrId: store.getters.userId,
    usrId: store.getters.userId,
    usrPhone: store.getters.getUserPhone,
  });

export const getSources = (fileIds) =>
  postFile("/filemanage/filecode/GetSources", {
    fileIds,
  });

export const getSource = (fileId) =>
  postFile("/filemanage/filecode/GetSource", {
    fileId,
  });

export const getFilePdfJpgKeys = (fileId) =>
  postFile("/filemanage/filecode/GetPdfJpgKeys", {
    fileId,
  });

export const getFileByKeys = (keys) =>
  postFile("/filemanage/filecode/GetFileByKeys", {
    coId: store.getters.coId,
    fileKeys: Array.isArray(keys) ? keys : [keys],
    sofId: store.getters.sofId,
  });

export const sourceToPdfFileUpload = (file: File) => {
  const formData = new FormData();
  formData.append("ManUsrId", store.getters.userId);
  formData.append("file", file);
  formData.append("CoId", store.state.coId);
  formData.append("SofId", String(store.state.sofId));
  return postFile("/filemanage/filecode/SourceToPdfFileUpload", formData);
};

export const getFileNameByFileIds = (fileIds: number[]) =>
  postFile("/filemanage/filecode/GetFileNames", {
    ids: fileIds,
  });

export const getImgToPdfSource = (fileName: string, fileIds: number[]) =>
  postFile("/filemanage/filecode/GetImgToPdfSource", {
    fileName,
    ids: fileIds,
    manUsrId: localStorage.userId,
    sofId: store.state.sofId,
    coId: store.state.coId,
  });

export const getPdfUrl = (fileId: number) =>
  postFile("/filemanage/filecode/GetPdfUrl", {
    fileId,
  });

export const getPdfPageCount = (fileId: number) =>
  getRequestFile("/filemanage/filecode/getPdfPageCount", {
    fileId,
  });

export const getOssConfig = ({ sofId }) => {
  return postFile("/filemanage/filecode/GetOssConfig", {
    sofId,
    coId: localStorage.coId,
  });
};

export const checkPdf2Img = (fileId) => {
  return getRequestFile("/filemanage/filecode/check_pdf2img", {
    fileId,
  });
};

export const getFileUploadUrl = ({ sofId, fileName }) => {
  const formData = new FormData();
  formData.append("ManUsrId", localStorage.userId);
  formData.append("fileName", fileName);
  formData.append("CoId", localStorage.coId);
  formData.append("SofId", String(sofId));
  return postFile("/filemanage/filecode/GetFileUploadUrl", formData);
};

export const getCompanyQRCodeAndWatermark = () => {
  return post("/quatrust/sys/GetCompanyQRCodeAndWatermark", {
    sofId: "10",
    coId: localStorage.coId,
  });
};
